import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./capture.template.html';

var CAPTURE_MODAL_ID = 'AssuranceCaptureModal';

function Capture(params) {
    var self = this;

    self.captureType = params.type;
    self.pageId = params.pageId;
    self.panelId = params.panelId;
    self.useDropdownStyle = params.useDropdownStyle;

    self.isPageCaptureType = ko.unwrap(self.captureType) === 'page' || ko.unwrap(self.captureType) === 'light';
    switch (self.captureType) {
      case 'page': self.captureButtonIcon = 'far fa-camera page-camera'; break;
      case 'light': self.captureButtonIcon = 'fal fa-camera page-camera'; break;
      default: self.captureButtonIcon = 'fal fa-camera page-camera';
    }
}

Capture.prototype = {
    captureImage: function (data, event) {
        var self = this;
        $('.tooltip').hide();
        self.showCaptureModal(event, self.pageId);
    },

    showCaptureModal: function (event, pageId) {
        var self = this;
        var parentIsEnabled = !($(event.target.parentElement).hasClass('disabled'));

        if (parentIsEnabled) {
            var modalEl = $('#' + CAPTURE_MODAL_ID);

            var captureModalVM = ko.dataFor(_.first(modalEl));
            captureModalVM.initialize(self.captureType, pageId, self.panelId);

            modalEl.one('shown.bs.modal', function (e) {
                captureModalVM.execute();
            });

            modalEl.modal('show');
        }
    }
};

ko.components.register('assurance-capture', { template: templateMarkup, viewModel: Capture });
